import { useEffect } from 'react';

import { isModalOpen } from 'src/utils/is-modal-open';
import analyticsClient, { AnalyticsEvent } from 'src/services/analytics';
import type { IConversation } from 'src/api/landlord-messages-api';
import type { IConversationMatchWithChannel } from 'src/pages/landlord/conversations/context/types';

type Props = {
    getFocusedConversation: () => IConversation | undefined;
    openConversation: (conversation: IConversation | IConversationMatchWithChannel, backPath: string) => void;
};

/**
 * Open the focused conversation when the enter key is pressed.
 */
export const useOpenConversationWithEnterKey = ({
    getFocusedConversation,
    openConversation
}: Props) => {

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Enter' && !isModalOpen()) {
                event.preventDefault();

                const focusedConversation = getFocusedConversation();
                if (focusedConversation) {
                    analyticsClient.track(AnalyticsEvent.SHORTCUT_KEY_USED, {
                        page: 'Conversations',
                        key: 'Enter',
                    });

                    openConversation(focusedConversation, window.location.pathname + window.location.search);
                }
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [getFocusedConversation, openConversation]);
};
